import type { OfferKey, OfferPreset } from "../types"
import { astrologyPreset } from "./presets/astrology"
import { compatibilityPreset } from "./presets/compatibility"
import { astromapPreset } from "./presets/astromap"
import { soulmatePreset } from "./presets/soulmate"
import { auraPreset } from "./presets/aura"

/** Canonical funnel order — offers always display in this sequence. */
export const OFFER_ORDER: OfferKey[] = [
  "astrology",
  "compatibility",
  "astromap",
  "soulmate",
  "aura",
]

/** Content presets keyed by offer. Presets are added per offer as they ship. */
export const OFFER_PRESETS: Partial<Record<OfferKey, OfferPreset>> = {
  astrology: astrologyPreset,
  compatibility: compatibilityPreset,
  astromap: astromapPreset,
  soulmate: soulmatePreset,
  aura: auraPreset,
}

/** Config param that carries the plan id for each offer (presence = enabled). */
export const OFFER_CONFIG_PARAM: Record<OfferKey, string> = {
  astrology: "astrology_report",
  compatibility: "compatibility_report",
  astromap: "astromap_report",
  soulmate: "soulmate_report",
  aura: "aura_report",
}
